import LAYOUT from '../LAYOUT';

/**
 * @since 0.22.0
 * @visibleName FORM
 * @component
 */
export default {
  DEFAULT_COL: LAYOUT.DEFAULT_COL,
  DEFAULT_COL_WIDTH: LAYOUT.DEFAULT_COL_WIDTH,
} as const;
